module.exports = __webpack_public_path__ + "static/media/DLF - Flat Logo Azul e Branco.183141db.svg";